/**
 * Cart update event system for reactive cart updates across components.
 */
import { CartView } from '../types/cartTypes';

const CART_UPDATE_EVENT = 'CART_UPDATE_EVENT';

export const emitCartUpdate = (cart: CartView | null) => {
  const event = new CustomEvent<CartView | null>(CART_UPDATE_EVENT, { detail: cart });
  window.dispatchEvent(event);
};

export const subscribeToCartUpdates = (callback: (cart: CartView | null) => void) => {
  const handler = (e: Event) => callback((e as CustomEvent<CartView | null>).detail);
  window.addEventListener(CART_UPDATE_EVENT, handler);
  return () => window.removeEventListener(CART_UPDATE_EVENT, handler);
};
